import { LocalStorageKey } from "../../local-storage-key";
import { getCookie, removeCookie } from "./cookie.util";

/**
 * CookieからLocalStorageへWebトラックトークンを復元する
 * アプリ起動時の最初期に1回実行する
 *
 * LP(neneru.com)から .neneru.com ドメインで設定されたcookieを読み取り、
 * expired-time が現在時刻より未来の場合のみ localStorage に復元する
 */
export function restoreWebTrackTokensFromCookie(): void {
  try {
    // ck-asp-track の復元
    restoreToken(
      "ck-asp-track",
      "ck-asp-track-expired-time",
      LocalStorageKey.User.CkAspTrack,
      LocalStorageKey.User.CkAspTrackExpiredTime
    );

    // gclid-track の復元
    restoreToken(
      "gclid-track",
      "gclid-track-expired-time",
      LocalStorageKey.User.GclidTrack,
      LocalStorageKey.User.GclidTrackExpiredTime
    );

    // referrer-url の復元（期限チェック不要）
    restoreReferrerUrl();
  } catch (e) {
    // Safari/プライベートブラウズ等で localStorage/cookie 制限があってもクラッシュしない
    console.warn("Failed to restore web track tokens from cookie:", e);
  }
}

/**
 * トークンと有効期限のペアを復元する
 */
function restoreToken(
  cookieTokenName: string,
  cookieExpiredTimeName: string,
  localStorageTokenKey: string,
  localStorageExpiredTimeKey: string
): void {
  try {
    const token = getCookie(cookieTokenName);
    const expiredTime = getCookie(cookieExpiredTimeName);

    if (token && expiredTime) {
      // 期限チェック: expired-time が現在時刻より未来の場合のみ復元
      if (Number(expiredTime) >= Date.now()) {
        // localStorageに既に値がある場合は上書きしない（localStorageの値を優先）
        if (!localStorage.getItem(localStorageTokenKey)) {
          localStorage.setItem(localStorageTokenKey, token);
          localStorage.setItem(localStorageExpiredTimeKey, expiredTime);
        }
      }
    }

    // Cookieは読み取り後に削除（期限切れでも削除）
    removeCookie(cookieTokenName);
    removeCookie(cookieExpiredTimeName);
  } catch (e) {
    console.warn(`Failed to restore token from cookie: ${cookieTokenName}`, e);
  }
}

/**
 * referrer-url を復元する
 */
function restoreReferrerUrl(): void {
  try {
    const referrerUrl = getCookie("referrer-url");

    if (referrerUrl) {
      // localStorageに既に値がある場合は上書きしない
      if (!localStorage.getItem(LocalStorageKey.User.ReferrerUrl)) {
        localStorage.setItem(LocalStorageKey.User.ReferrerUrl, referrerUrl);
      }
    }

    // Cookieは読み取り後に削除
    removeCookie("referrer-url");
  } catch (e) {
    console.warn("Failed to restore referrer-url from cookie:", e);
  }
}
